import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { makeSelectHasRole, useUserStore } from "@/lib/userStore.ts";
import { ROLES } from "@/features/roles/types.ts";

export const Route = createFileRoute("/_auth/_isAdmin")({
  beforeLoad: ({ location }) => {
    const state = useUserStore.getState();

    if (state.status !== "authenticated") {
      return;
    }

    const hasRole = makeSelectHasRole(ROLES.ADMIN)(state);
    if (!hasRole) {
      throw redirect({
        to: "/forbidden",
        search: { redirect: location.href, required: ROLES.ADMIN },
        replace: true,
      });
    }
  },
  component: AdminLayout,
});

function AdminLayout() {
  return <Outlet />;
}
